import { ResetPassword } from '@/modules/authentication'
import { ForgottenPassword, Login } from '@/modules/login'
import { WorkPeriodDateCellPreview } from '@/modules/salary'
import MicrosoftLoginPage from '@/modules/login/MicrosoftLoginPage'
import TeamsMicrosoftAuth from '@/modules/login/MicrosoftLogin/TeamsMicrosoftAuth'
import { CreatePassword } from '@/modules/users/RegisterUser/CreatePassword'
import { AcceptCompanyInvitation } from '@/modules/users/RegisterUser/accept-company-invitation'
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router'
import { useEffect } from 'react'

export function NoAuthRoutes() {
  function RedirectToLogin() {
    const location = useLocation()

    useEffect(() => {
      localStorage.setItem(
        'FIRMADOK_REDIRECT_LOGIN',
        `${location.pathname}${location.search}${location.hash}`
      )
    }, [location])

    return <Navigate to="/login" replace />
  }
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login/teams-auth" element={<TeamsMicrosoftAuth />} />

        <Route path="/login/microsoft" element={<MicrosoftLoginPage />} />

        <Route path="/login" element={<Login />} />

        <Route path="/create-password/:urlId" element={<CreatePassword />} />

        <Route
          path="/accept-company-invitation/:urlId"
          element={<AcceptCompanyInvitation />}
        />

        <Route path="/forgotten-password" element={<ForgottenPassword />} />

        <Route path="/reset-password/:urlId" element={<ResetPassword />} />

        <Route
          path="/preview/work-period-date-cells"
          element={<WorkPeriodDateCellPreview />}
        />

        <Route path="*" element={<RedirectToLogin />} />
      </Routes>
    </BrowserRouter>
  )
}
